import HttpGlobal from "../Global/HttpGlobal.class";
import {
  ConsentEntry,
  ConsentsPayload,
  getPrivacyPolicyVersion,
  isConsentCaptureEnabled,
  logConsentDev,
  restorePendingConsents,
  takePendingConsents,
} from "../../../utils/consentCapture";

export default class HttpConsentsRepository extends HttpGlobal {
  private readonly API_URL_LEAD: string = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/lead`;

  /** `POST /api/lead/{ulid}/consents` con el token del lead. */
  recordConsents = async (payload: ConsentsPayload): Promise<unknown> =>
    this.generalPost({
      url: `${this.API_URL_LEAD}/${this.leadId}/consents`,
      dataRequest: payload,
    });
}

/**
 * Registra consentimientos sin bloquear nunca el funnel: si el flag está apagado
 * no hace nada; si el endpoint falla (aún no existe, red, 4xx/5xx) devuelve
 * `false` y solo lo traza en desarrollo. Nunca lanza.
 */
export const recordConsentsSafely = async (
  leadId: string | undefined,
  token: string | undefined,
  consents: ConsentEntry[]
): Promise<boolean> => {
  if (!isConsentCaptureEnabled() || !leadId || !token || 0 === consents.length) {
    return false;
  }
  const payload: ConsentsPayload = {
    policyVersion: getPrivacyPolicyVersion(),
    consents,
  };
  try {
    await new HttpConsentsRepository(leadId, token).recordConsents(payload);
    logConsentDev("recorded", consents.map((c) => `${c.purpose}=${c.granted}`));
    return true;
  } catch (error) {
    logConsentDev("record failed (ignored)", (error as { status?: number })?.status ?? "network");
    return false;
  }
};

/**
 * Envía los consentimientos que quedaron pendientes por falta de token (casillas
 * del calculador). Si vuelve a fallar los deja guardados para el siguiente intento.
 */
export const flushPendingConsents = async (
  leadId: string | undefined,
  token: string | undefined
): Promise<void> => {
  if (!isConsentCaptureEnabled() || !leadId || !token) return;
  const pending = takePendingConsents(leadId);
  if (0 === pending.length) return;
  const sent = await recordConsentsSafely(leadId, token, pending);
  if (!sent) restorePendingConsents(leadId, pending);
};
